import { connect } from 'react-redux'
import { isMobileOnly } from 'react-device-detect'
import { withRouter } from 'react-router-dom'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import {
  getNotificationsLoadedGetNotifications,
  getNotificationsUnreadCount,
} from 'store/entities/notifications/selectors'
import { notifications, notificationsMarkedRead, notificationsUnreadCount } from 'store/entities/notifications/actions'
import NotificationBar from './NotificationBar'

const mapStateToProps = state => ({
  loaded: getNotificationsLoadedGetNotifications(state),
  unreadCount: getNotificationsUnreadCount(state),
  isMobileOnly,
})

const mapDispatchToProps = {
  onLoadNotifications: notifications.get.request,
  onRequest: notificationsUnreadCount.get.request,
  markNotificationsRead: notificationsMarkedRead.get.request,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(NotificationBar)))
